// React imports.
import React, { useMemo } from "react";

//library imports
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// App imports.
import { IndexHistory } from '../state'
import * as utility from "../utility";
import ReadingIndexValues from "./ReadingIndexValues";

interface BenefitTargeting3Props {
  history: IndexHistory;
}

function BenefitTargeting3({ history }: BenefitTargeting3Props) {
  // Add safety check for EarliestYear
  const defaultYear = '2016';
  const earliestYearValue = history.EarliestYear && history.EarliestYear.Year ? history.EarliestYear.Year : defaultYear;

  // Initialize options with useMemo to avoid recalculation
  const options = useMemo(() => {
    const baseOptions = {
      credits: {
        enabled: false
      },
      chart: {
        type: 'line',
      },
      title: {
        text: history.SelectedIndexString + ' Index'
      },
      xAxis: {
        title: {
          text: 'Federal Fiscal Year'
        },
        labels: {
          enabled: true,
        },
        categories: [] as string[]
      },
      yAxis: {
        plotLines: [{
          color: '#FF0000',
          width: 2,
          value: 100,
          dashStyle: 'ShortDash',
        }],
        min: 0,
        max: 200,
        title: {
          text: history.SelectedIndexString + ' Index'
        }
      },
      series: [
        {
          name: history.SelectedIndexString + ' Index',
          data: [] as number[],
          showInLegend: false,
        }
      ],
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true
          },
          pointStart: +earliestYearValue
        }
      },
    };

    // Iterate years adding benefit matrix to data and year to xaxis
    let dataArray: number[] = [];
    let prevHighDataPoint: number = 0;
    
    history.IndexYears.forEach(yr => {
      let dataPoint = history.IndexCode === utility.IndexCodeEnum.TargetingIndex
        ? +yr.BenefitTargetingIndex
        : +yr.BurdenReductionIndex;
      dataArray.push(+dataPoint);
      baseOptions.xAxis.categories.push(String(yr.Year));

      // Update the y axis if value is too high for 0-200 range normally set
      if (dataPoint > 200 && dataPoint > prevHighDataPoint) {
        baseOptions.yAxis.max = dataPoint + 30;
        prevHighDataPoint = dataPoint;
      }
    });
    
    baseOptions.series[0].data = dataArray;
    
    return baseOptions;
  }, [history, earliestYearValue]);

  return (
    <div >
      <h2>{history.SelectedIndexString}   Index – Change Over Time</h2>
      <br />

      {(history.IndexYears.length > 1)
        &&
        <React.Fragment>
          Below are  {history.GranteeName}'s  {history.SelectedIndexString}    Index scores for
          the last {history.IndexYears.length} reporting years.
          <br />
          <br />


          <table>
            <thead>
              <tr>
                <th>Fiscal Year</th>
                <th>{history.SelectedIndexString}  Index</th>
                <th>Number of Bill Payment Assisted Households</th>
                <th>Number of Bill Payment Assisted Households with Complete Performance Data</th>
                <th>Percentage of Bill Payment Assisted Households Represented by Your Performance Data</th>
              </tr>
            </thead>
            <tbody>
              {history.IndexYears.map(y => {
                return (
                  <tr key={y.Year}>
                    <td>
                      {y.Year}
                    </td>
                    <td>
                      {history.IndexCode === utility.IndexCodeEnum.TargetingIndex
                        ? y.BenefitTargetingIndex : y.BurdenReductionIndex}
                    </td>
                    <td>
                      {y.HouseholdsAssisted.toLocaleString()}
                    </td>
                    <td>
                      {y.HouseholdsCompleteData.toLocaleString()}
                    </td>
                    <td>
                      {y.IndexRepresentsPctString}
                    </td>

                  </tr>
                )
              })}
            </tbody>
          </table>


          <br />
          <br />
          <div className="container">
            <div className="row">
              <div className="col-sm-7">
                <HighchartsReact highcharts={Highcharts} options={options} />
              </div>
              <div className="col-sm-5 takeaways">
                <ReadingIndexValues history={history} />
              </div>
            </div>
          </div>

        </React.Fragment>
      }
      {(history.IndexYears.length < 2)
        && <React.Fragment>
          Not enough performance measurement data has been submitted to display trends and history.
        </React.Fragment>
      }
      <br /><br />
      <p> <span>Please click <em>Next </em>to continue.</span></p>

    </div>
  )
}

export default BenefitTargeting3;

